module.exports = function(video) {
	"use strict";
  video
  .controller('videoCategoryEditController', videoCategoryEditController)
	videoCategoryEditController.$inject = ["$attrs","$scope","$state","$stateParams","getDataService","refreshtokenService","reqursiveService","putDataService","alertService","$rootScope","serverError","offlineError"]
	
  function videoCategoryEditController($attrs,$scope,$state,$stateParams,getDataService,refreshtokenService,reqursiveService, putDataService, alertService,$rootScope,serverError,offlineError) {
    var vmvce = this;
    var state = 'video-categories'
    $scope.parent = $scope.$eval($attrs.parent);
    $rootScope.closeEditVideoCategory = function() {
      $scope.parent.categoryEdit = false;
      vmvce.category = null;
      vmvce.selectedCategory= {value: 'none'};
      $state.transitionTo('app.video_categories', {id: null}, {
        location: true,
        inherit: true,
        relative: $state.$current,
        notify: false
      });
    }
    vmvce.categoryId = $scope.parent.categoryId;
    var getCategoryFunction = function() {
      $rootScope.hasLoaded = false;
      getDataService.get({param1:state, param2: vmvce.categoryId}).$promise.then(function(data){
        $rootScope.hasLoaded = true;
        vmvce.category = data;
        // vmvce.getAllCategories();
        if(vmvce.category.parent) {
          vmvce.selectedCategory= {value: vmvce.category.parent};
        } else {
          vmvce.selectedCategory= {value: 'none'};
        }
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {
                getCategoryFunction();
              }
              // do something
            },
            function(error) {
            },
            function(progress) {
             // report progress
          });
        } else if(error.status ==502) {
          serverError()
        }  else {
          $scope.parent.categoryEdit = false;
          $state.transitionTo('app.video_categories', {id: null}, {
            location: true,
            inherit: true,
            relative: $state.$current,
            notify: false
          });
        }
        $rootScope.hasLoaded = true;
      });
    }
    getCategoryFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/video-category-edit/js/videoCategoryEditController.js
// module id = 653
// module chunks = 0